/**
 * Client-side slug helper. Keep in sync with the server's slugifyName in
 * src/lib/slug.ts — same rules so the preview the admin sees matches what
 * the server will actually store.
 */
export function slugifyName(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 60);
}
